import React from 'react';
import { Outlet } from 'react-router';

import { PrototypeProvider } from './PrototypeContext';
import PrototypeSidebar from './PrototypeSidebar';

const PrototypeLayout: React.FC = () => {
  return (
    <PrototypeProvider>
      <PrototypeSidebar>
        <Outlet />
      </PrototypeSidebar>
    </PrototypeProvider>
  );
};

export default PrototypeLayout;
